<div *ngIf="isVisible" class="pix-modal-overlay">
  <div class="pix-modal-container">
    <button class="pix-modal-close-button" (click)="closeModal()">&times;</button>
    <div class="pix-modal-content">
      <img [src]="qrCodeLink" alt="QR Code" class="pix-modal-qr" />
      <button class="pix-modal-copy-button" (click)="copyPixCode()">Copiar Código</button>
    </div>
    <span>Este codigo pix tem duração de 1 hora. Após este tempo, o mesmo ficará inválido para pagamento</span>
  </div>
</div>


<app-alert></app-alert>
